export default __webpack_public_path__ + "static/media/fundo-branco-elegante-com-linhas-brilhantes_1017-17580.398d7d2b.png";